import { h, render } from 'preact';
import CategoryMarquee from '~/components/CategoryMarquee';
import MostRecent from '../../components/MostRecent/MostRecent';
import PopularPodcasts from '../../components/PopularPodcasts';
import inView from '~/utils/in-view';
import createLeeAdObserver from '~/utils/leeadObserver';
import http from '~/shared/http';
import { chartblock } from '~/routes';
import 'intersection-observer';
import { createChartInfiniteScroll, findAdNodes } from './infiniteScroll';

function observeGrid() {
    inView('.items-grid').once('enter', (el) => {
        if (!el.classList.contains('items-grid--in-view')) {
            el.className += ' items-grid--in-view';
        }
    });
}

function createNodes(htmlString: string): Element[] {
    const outer = document.createElement('div');
    outer.innerHTML = htmlString;

    return [...outer.children];
}

function mountCategoryMarquee() {
    const categoryMarqueeNode = document.querySelector('#category-marquee');
    const propsNode = categoryMarqueeNode?.querySelector('[data-category-marquee-props]');

    if (!categoryMarqueeNode || !propsNode?.textContent) {
        return;
    }

    try {
        const props = JSON.parse(propsNode.textContent);

        render(h(CategoryMarquee, props), categoryMarqueeNode);
    } catch (error) {
        console.error('Failed to render category marquee:', error);
    }
}

function topchart() {
    observeGrid();
    const adObserver = createLeeAdObserver();

    const lastChartBlock = document.querySelector(
        'section.container .row > section.items-grid:last-of-type',
    );
    const root = lastChartBlock?.parentElement;

    if (lastChartBlock && root) {
        createChartInfiniteScroll({
            root,
            initialChartBlock: lastChartBlock,
            initialUrl: chartblock.url({ query: { page: 2 } }),
            fetchPage: async (url) => {
                const { data, headers } = await http.get<string>(url);

                return {
                    nodes: createNodes(data),
                    nextUrl: headers.get('link') || null,
                };
            },
            onNodesAdded: (nodes) => {
                adObserver.add(findAdNodes(nodes));
                observeGrid();
            },
        });
    }

    const popularPodcastsNode = document.querySelector('#popularpodcasts');
    if (popularPodcastsNode) {
        render(
            h(PopularPodcasts, {
                title: 'Populärt på Poddtoppen just nu',
                slot: 'popular.horizontal.home',
                action: '/populara',
            }),
            popularPodcastsNode,
        );
    }

    mountCategoryMarquee();

    const mostRecentNode = document.querySelector('#mostrecent');
    if (mostRecentNode) {
        render(
            h(MostRecent, {
                title: 'Senast besökta',
            }),
            mostRecentNode,
        );
    }
}

topchart();
